import React from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

const DEFAULT_LABEL = 'This feature'

interface DeprecatedProps {
  children: React.ReactNode
  label?: string
  plural?: boolean
  delayDuration?: number
}

const getTooltipContent = (
  props: Omit<DeprecatedProps, 'children' | 'delayDuration'>,
) => {
  const { label = DEFAULT_LABEL, plural = false } = props
  if (plural) {
    return `${label} are deprecated and will be removed in a future release.`
  }
  return `${label} is deprecated and will be removed in a future release.`
}

export const Deprecated: React.FC<DeprecatedProps> = (props) => {
  const { children } = props
  const tooltipContent = getTooltipContent(props)
  return (
    <TooltipProvider>
      <Tooltip delayDuration={props.delayDuration || 0}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="max-w-[300px]">
          {tooltipContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
